import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface LoadingState {
	isLoading: boolean;
	message?: string;
	hint?: string;
}

@Injectable({
	providedIn: "root",
})
export class LoadingService {
	private loadingSubject = new BehaviorSubject<boolean>(false);
	private messageSubject = new BehaviorSubject<string | undefined>(undefined);
	/** A second line for work that is expected to take a while. */
	private hintSubject = new BehaviorSubject<string | undefined>(undefined);
	private loadingCounter = 0;

	loading$: Observable<boolean> = this.loadingSubject.asObservable();
	message$: Observable<string | undefined> = this.messageSubject.asObservable();
	hint$: Observable<string | undefined> = this.hintSubject.asObservable();

	setLoading(isLoading: boolean, message?: string, hint?: string): void {
		if (isLoading) {
			this.loadingCounter++;
			this.messageSubject.next(message);
			this.hintSubject.next(hint);
		} else {
			this.loadingCounter = Math.max(0, this.loadingCounter - 1);
			if (this.loadingCounter === 0) {
				this.messageSubject.next(undefined);
				this.hintSubject.next(undefined);
			}
		}
		this.loadingSubject.next(this.loadingCounter > 0);
	}

	startLoading(message?: string, hint?: string): void {
		this.setLoading(true, message, hint);
	}

	stopLoading(): void {
		this.setLoading(false);
	}

	// Force stop all loading (reset counter)
	forceStopLoading(): void {
		this.loadingCounter = 0;
		this.loadingSubject.next(false);
		this.messageSubject.next(undefined);
		this.hintSubject.next(undefined);
	}
}
